import api from "../../../services/api";

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import * as globalComponents from "../../../components";

import "../styles.css";

export default function SocialActionsScene() {
  const { accessType, socialActionID } = useParams();
  const [data, setData] = useState([]);

  const dir = [
    {
      title: "Ações Sociais",
      url: `/${accessType}/acoes_sociais`,
    },
  ];

  useEffect(() => {
    window.scroll(0, 0);
    async function fetchData() {
      await api
        .get(`/conteudo/${socialActionID.split("_").pop()}`)
        .then((response) => {
          setData(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    fetchData();
  }, [socialActionID]);

  return (
    <>
      <globalComponents.Header />

      <globalComponents.Breadcrumbs
        title={`Ação Social ${socialActionID.split("_").pop()}`}
        dir={dir}
      />

      <div className="container">
        <div className="content-wrapper">
          <globalComponents.PageTitle
            title={data.Titulo}
            subtitle={data.Subtitulo}
            span={data.Data_Publicacao}
          />

          <div className="content-image">
            <img src={data.Nome_Arquivo} alt="" />
          </div>

          <div
            className="content-text"
            dangerouslySetInnerHTML={{ __html: data.Materia }}
          ></div>
        </div>
      </div>

      <globalComponents.Footer />
    </>
  );
}
